var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.597 24.403l7.539-7.539c.452-.452.679-.678.94-.763.229-.075.476-.075.706 0 .26.085.487.31.94.763l7.488 7.489m-6.496-6.496l3.279-3.278c.452-.453.679-.68.94-.764.23-.075.476-.075.706 0 .26.085.487.311.94.764l3.278 3.278M12.143 11a2.286 2.286 0 11-4.572 0 2.286 2.286 0 014.572 0zM8.486 24.714H20.37c1.92 0 2.88 0 3.614-.373a3.43 3.43 0 001.498-1.499c.374-.733.374-1.693.374-3.613v-9.6c0-1.92 0-2.88-.374-3.614a3.429 3.429 0 00-1.498-1.498c-.733-.374-1.693-.374-3.614-.374H8.486c-1.92 0-2.88 0-3.614.374a3.429 3.429 0 00-1.498 1.498C3 6.748 3 7.708 3 9.629v9.6c0 1.92 0 2.88.374 3.613a3.43 3.43 0 001.498 1.499c.733.373 1.694.373 3.614.373z",
    stroke: "#667085",
    strokeWidth: 2.286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgImage03;